import dayjs from 'dayjs';
import { LoginStore } from '@model/login';
import { isPCCheck } from '@utils/tools';
import { LX_SEARCH_CLICK } from '@common/const';
import { pathInfo } from '@src/Router/pathList';
import isDx from '@block/utils/lib/is/isDX';
import md5 from 'md5';
import lxFn from './lxFn';

/* eslint-disable */
// valLab中的custom参数
export let custom = {
  systemName: '招聘官网',
  tanentId: 1, // 业务线 id 1：用户端/2：管理端/3.待补充
  platform: isPCCheck() ? 'pc' : 'h5',
  src_app_name: isDx() ? 'daxiang' : 'browser', // daxiang 大象;browser 浏览器;
  ip: '',
  u_query_id: '',
  r_query_id: '',
};

// 每次搜索生成一组u_query_id和r_query_id
export const getCustom = (keyword?) => {
  const random = Math.random();
  const {
    userInfo: { accountId, clientIp },
  } = LoginStore;
  custom = {
    ...custom,
    ip: clientIp,
    u_query_id: md5(`${accountId || custom.ip}+${keyword || ''}+${new Date().getTime()}`),
    r_query_id: `${new Date().getTime().toString() + Math.round(random * 100000000)}`,
  };
};
/* eslint-enable */

// valLab 自定义需要传入的信息
// 关键词：keywords
// 职位类型：jobType: 'social' or 'campus
// 简历身份：resumeType: 'social' or 'campus'
// bid
/*
LxSiteClick({bid: 'xxxx', valLab:{keywords:'xxx',jobType: 'social', resumeType: 'social'})
 */

// 点击埋点
export const LxSiteClick = ({ options = null, bid, valLab = {} }) => {
  if (!bid) return;
  const {
    userInfo: { accountId, clientIp },
  } = LoginStore;
  let clickInfo = {};
  clickInfo = { ...valLab, time: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss') };
  if (accountId) {
    clickInfo = {
      ...clickInfo,
      accountId,
    };
  }
  // @ts-ignore
  if (valLab.entry_point && !valLab.page_no) {
    // @ts-ignore
    getCustom(valLab.query_keyword);
    clickInfo = {
      custom: {
        ...custom,
        ...valLab,
        ip: clientIp,
        userid: accountId || '',
      },
    };
  }
  // @ts-ignore
  if (valLab.page_no) {
    clickInfo = {
      custom: {
        ...custom,
        ...valLab,
        ip: clientIp,
        userid: accountId || '',
      },
    };
  }
  lxFn.moduleClick(bid, clickInfo, options);
};

/**
 * MC事件埋点
 * @param {string} options
 * @param {string} bid
 * @param {object} valLab 自定义需要传入的信息
 */
export const LxModuleView = ({ options = null, bid, valLab = {} }) => {
  if (!bid) return;
  const {
    userInfo: { accountId, clientIp },
  } = LoginStore;
  let clickInfo = {};
  clickInfo = { ...valLab, time: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss') };
  if (accountId) {
    clickInfo = {
      ...clickInfo,
      accountId,
    };
  }
  // @ts-ignore
  if (valLab.query_keyword !== undefined) {
    clickInfo = {
      custom: {
        ...custom,
        ...valLab,
        ip: clientIp,
        userid: accountId || '',
      },
    };
    // @ts-ignore
  } else if (valLab.entry_point) {
    /* eslint-disable */
    const { systemName, tanentId, platform, src_app_name, ip } = custom;
    clickInfo = {
      custom: {
        systemName,
        tanentId,
        platform,
        src_app_name,
        ip: clientIp,
        ...valLab,
        userid: accountId || '',
      },
    };
    /* eslint-enable */
  }
  lxFn.moduleView(bid, clickInfo, options);
};

/**
 * PV事件埋点
 * @param {string} options
 * @param {string} bid
 * @param {object} valLab 自定义需要传入的信息
 */
export const LxPageView = ({ cid, valLab = {} }) => {
  if (!cid) return;
  const {
    userInfo: { accountId },
  } = LoginStore;
  let clickInfo = { ...valLab, time: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss') };
  if (accountId) {
    clickInfo = {
      ...clickInfo,
      // @ts-ignore
      accountId,
    };
  }
  lxFn.pageView(cid, clickInfo);
};

// 搜索MC/PV事件参数
export const lxSearchClickInfo = (path, type?) => {
  if (type) {
    let bid = '';
    // eslint-disable-next-line
    type === 'MC'
      ? (bid = 'b_ead_4n6d2gms_mc')
      : type === 'MV'
        ? (bid = 'b_ead_wc82rljc_mv')
        : (bid = 'b_ead_2x7zthr4_mv');
    if (path === pathInfo.campus) return { bid, entry: '2' };
    if (path === pathInfo.social) return { bid, entry: '3' };
    if (path === pathInfo.ourTeam) return { bid, entry: '10' };
    if (path === pathInfo.position || path === pathInfo.beidou || path === pathInfo.qihang || path === pathInfo.trainee)
      return { bid, entry: '4' };
  } else {
    if (path === pathInfo.campus) return { bid: LX_SEARCH_CLICK.campus, entry: '2' };
    if (path === pathInfo.social) return { bid: LX_SEARCH_CLICK.social, entry: '3' };
    if (path === pathInfo.position || path === pathInfo.beidou || path === pathInfo.qihang || path === pathInfo.trainee)
      return { bid: LX_SEARCH_CLICK.position, entry: '4' };
    if (path === pathInfo.ourTeam) return { bid: LX_SEARCH_CLICK.about, entry: '10' };
  }
  return null;
};
